import React from 'react';
import { getCategoryData } from '../../../../../../api';
import './CategoryItems.css';
import CategoryItem from './CategoryItem/CategoryItem';
import { TEXT } from '../../../../../../content';
import { PATH } from '../../../../../../constants';

const getCategoryItem = (id, categoryId, msgCount) => (
  <CategoryItem key={id} id={id} categoryId={categoryId} msgCount={msgCount} />
);

const getCategoryTitle = (imgName, title) => (
  <div className="category-title">
    <img
      className="category-title-deco"
      src={`${PATH.IMG}deco/category-${imgName}.png`}
      alt=""
    />
    {title}
  </div>
);

const CategoryItems = props => {
  const { categoryId, msgCount } = props;
  const categoryData = getCategoryData(categoryId);

  const videos = categoryData.v.map(id =>
    getCategoryItem(id, categoryId, msgCount[id])
  );
  const photos = categoryData.i.map(id =>
    getCategoryItem(id, categoryId, msgCount[id])
  );

  return (
    <div id="category-links">
      {videos.length > 0 && (
        <div>
          {getCategoryTitle('video', TEXT.VIDEOS)}
          {videos}
        </div>
      )}
      {photos.length > 0 && (
        <div>
          {getCategoryTitle('photo', TEXT.PHOTOS)}
          {photos}
        </div>
      )}
    </div>
  );
};

export default CategoryItems;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/CategoryList/CategoryItems/CategoryItems.js